var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('Header',{attrs:{"title":"contact"}}),_vm._v(" "),_c('Banner',{attrs:{"bgImg":_vm.bannerImg,"height":"900","title":'contact',"prjPosit":'leftP'}}),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }